import { ICommandMapper } from '../ICommandMapper';
import { DeleteAdHocTaskCommand, OfflineEditableCommand } from '@/models/api';
import { EditStore, Edit } from '../EditStore';
import ConvertCommandsToBaselineHelper from './Helpers/ConvertCommandsToBaselineHelper';

export class DeleteAdHocTaskCommandMapper implements ICommandMapper<DeleteAdHocTaskCommand> {
    commandType = 'DeleteAdHocTaskCommand';
    async onQueue(command: DeleteAdHocTaskCommand, store: EditStore) {
        await ConvertCommandsToBaselineHelper.onQueue(command, store);
    }
    onDequeue(edit: Edit<OfflineEditableCommand>, attemptedAt: Date): Edit<any> {
        return ConvertCommandsToBaselineHelper.onDequeue(edit, attemptedAt);
    }
    mappers = [ConvertCommandsToBaselineHelper.createShiftModelMapper<DeleteAdHocTaskCommand>()];
}

export default new DeleteAdHocTaskCommandMapper();
